<template>
  <div>
    <li @click="showModal">
      <span class="img icon-type-7"></span>
      <p class="text">模式</p>
    </li>

    <mt-popup v-model="showModel" modal="false" class="pubPopup" popup-transition="popup-fade" position="bottom">
      <p class="tipText">模式切换</p>
      <mt-radio title="" v-model="eqModeVal"
                :options="eqInfo.airVentilator.workingMode1 === '1' ? this.modelList : this.modelList"></mt-radio>
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeMode">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelModel">取消</mt-button>
      </p>
    </mt-popup>
    <div class="tip detail_tip" v-show="showTip">
      <div class="content">
        <div class="tip_body">
          <div class="modal-warning">
            <span></span>
            <p>温馨提示：请关机后再切换模式</p>
          </div>
        </div>
        <div class="tip_foot tip_foot_detail"><span @click="hideTips">取消</span></div>
      </div>
    </div>
  </div>
</template>
<script>
import {Toast} from 'mint-ui';

export default {
  name: 'EqModal',
  props: ['eqInfo', 'id'],
  data() {
    return {
      showTip: false,
      showModel: false,
      modelList: [
        {
          value: '1',
          label: '制热'
        },
        {
          value: '0',
          label: '制冷'
        },
        {
          value: '2',
          label: '通风'
        }
      ],
      modelListFan: [
        {
          value: '2',
          label: '制热'
        },
        {
          value: '1',
          label: '制冷'
        },
        {
          value: '5',
          label: '通风'
        },
        {
          value: '7',
          label: '地暖'
        },
        {
          value: '8',
          label: '制热+地暖'
        }
      ],
      eqModeVal: '0'
    };
  },
  methods: {
    getId() {
      return this.id;
    },
    showModal() {
      if (this.eqInfo.airVentilator.systemStatus1 === '4' ||
          this.eqInfo.airVentilator.systemStatus1 === '5' ||
          this.eqInfo.airVentilator.systemStatus1 === '6'
      ) {
        this.showTip = true
      } else {
        this.showModel = true;
        this.eqModeVal = String(this.eqInfo.airVentilator.workingMode1);
      }
    },
    cancelModel() {
      this.hideModal();
    },
    hideModal() {
      this.showModel = false;
    },
    hideTips() {
      this.showTip = false;
    },
    changeMode() {
      let flag = this.eqModeVal;
      if (flag === '0') {
        this.adjustCoolMode();
      }
      if (flag === '1') {
        this.adjustHeatMode();
      }
      if (flag === '2') {
        this.adjustVentilationMode();
      }
    },
    // 切换制热模式
    adjustHeatMode() {
      let data = {
        "iotDeviceId": parseInt(this.getId()),
      }
      this.Api.freshAdjustHeatMode(data, (msg) => {
        if (msg.code === 200) {
          Toast('设置制热模式成功');
          this.hideModal();
          this.$emit('init');
        } else {
          Toast(msg.message);
          this.hideModal();
          this.eqModeVal = String(this.eqMode);
        }
      });
    },
    // 切换制冷模式
    adjustCoolMode() {
      let data = {
        "iotDeviceId": parseInt(this.getId()),
      }
      this.Api.freshAdjustCoolMode(data, (msg) => {
        if (msg.code === 200) {
          Toast('设置制冷模式成功');
          this.hideModal();
          this.$emit('init');
        } else {
          Toast(msg.message);
          this.hideModal();
          this.eqModeVal = String(this.eqInfo.equipmentMode);
        }
      });
    },
    // 切换通风模式
    adjustVentilationMode() {
      let data = {
        "iotDeviceId": parseInt(this.getId()),
      }
      this.Api.freshAdjustVentilationMode(data, (msg) => {
        if (msg.code === 200) {
          Toast('设置通风模式成功');
          this.hideModal();
          this.$emit('init');
        } else {
          Toast(msg.message);
          this.hideModal();
          this.eqModeVal = String(this.eqInfo.equipmentMode);
        }
      });
    }
  }
};
</script>
<style>
.p-ui {
  padding: 20px 10px;
}

.p-ui2 {
  padding: 0 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/commen/eqModal/index.vue